export const cleanPostcode = (string: string): string => {
  if (!string) {
    return "";
  }
  const noWhiteSpace = string.replace(/\s/g, "");
  const uppercase = noWhiteSpace.toUpperCase();
  return uppercase;
};
